<div id="main-content" *ngIf="afDisclosureInfo ; else loading" class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent($event)">
  <form [formGroup]="ackData" (ngSubmit)="onSubmit()">

    <h1 class="bofa--heading is-4 double-bottom-space">Acknowledgment of Employment Terms and Information</h1>
    <div>
        <div class="print-flex padding-top display-zoom">
          <p class="no-bottom bottom-space-zoom"> {{ ackTerms }} </p>
          <button type="button" class="bofa--button secondary outlined print-button" (click)="print()">
            <img class="print-img" src="assets/bofa_icon_print2_280rgb.svg" alt="" role="img"><span
              class="button-text">Print</span></button>
        </div>
  
        <div id="print-section" class="discTerms" tabindex="0" [innerHTML]="authLanguageLookup | safeHtml"></div>
  
        <div class="padding-top">
          <mat-checkbox aria-required="true" class="minor-check-padding" required (focusout)="termsOnBlur()"
            (focusin)="termsOnFocus()" formControlName="discTermsCheck">
            <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I certify that I have read and
              understand the information presented
            </mat-label>
          </mat-checkbox>
          <mat-error class="whitespace-normal" *ngIf="discTermsCheck.hasError('invalid') && check"> Please check the
            box to agree to the above language </mat-error>
  
          <mat-form-field class="margin-left-space max-zoom radio-padding width-350-margins">
            <mat-label>Date Signed</mat-label>
            <input value="{{ termDate }}" matInput disabled>
          </mat-form-field>
        </div>
    </div>

    <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed the
        information above</p>
  
      <div class="width-750-margins" *ngIf="afDisclosureInfo">
        <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
        </app-wet-signature>
        <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
      </div>
  
      <mat-checkbox aria-required="true" required (focusout)="legalOnBlur()" (focusin)="legalOnFocus()"
        formControlName="legalRequirementsMet" class="minor-check-padding">
        <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully reviewed and
          completed the information above
        </mat-label>
      </mat-checkbox>
      <mat-error class="whitespace-normal" *ngIf="legalRequirementsMet.hasError('invalid') && checkTwo"> Please check
        the box to agree to the above language </mat-error>
  
      <div>
        <mat-form-field class="max-zoom width-350-margins" 
          hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="applicantSignedName" required maxlength="250">
          <mat-error>Please enter a valid full name</mat-error>
        </mat-form-field>
      </div>
  
      <div>
        <mat-form-field class="max-zoom width-350">
          <mat-label>Date Signed</mat-label>
          <input value="{{ date }}" matInput disabled>
        </mat-form-field>
      </div>
  
  </form>
</div>
<ng-template #loading>
  Loading Acknowledgement Information...
</ng-template>
